// import logo from './logo.svg';
import './App.sass';

function App() {
  // 根据视口宽度判断是否为移动端
  const isMobile = () => {
    const userAgentInfo = navigator.userAgent;
    const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone'];
    let flag = false;
    for (let v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = true;
        break;
      }
    }
    return flag;
  }

  const linkBox = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '20px',
  }

  const aLink = {
    padding: '0 10px',
    fontSize: '20px',
    fontWeight: 'bold',
    // 蓝色下划线
    textDecoration: 'underline',
    color: '#61dafb',
  }

  if (isMobile()) {
    // 修改flex为column
    linkBox.display = 'flex';
    linkBox.flexDirection = 'column';
    linkBox.marginTop = '0px';
    linkBox.marginBottom = '20px';
    aLink.padding = '5px 0';
  }

  return (
    <div className="App">
      <header className="App-header">
        <h1>hahawode</h1>
        {/* <img src={logo} className="App-logo" alt="logo" /> */}
        <div style={linkBox}>
          <a style={aLink} href="https://miloweimo.github.io/article/">Blog</a>
          <a style={aLink} href="https://miloweimo.github.io/demo/">Demo</a>
          {/* <a style={aLink} href="https://miloweimo.github.io/demo2/">Demo2</a> */}
          {/* <a style={aLink} href="https://miloweimo.github.io/utilities/">Utilities</a> */}
          <a style={aLink} href="https://miloweimo.github.io/tools/">Tools</a>
          <a style={aLink} href="https://github.com/miloweimo">GitHub</a>
        </div>
      </header>
      <div className="layer1" />
      <div className="layer2" />
      <div className="layer3" />
      <div className="layer4" />
      <div className="layer5" />
      <div className="layer6" />
    </div>
  );
}

export default App;
